module.exports = __webpack_public_path__ + "media/images/job_list/icon_ad-b312bf26e4527a16abbb7ded7c4bf8bb.png";